import React, { useState, useEffect } from 'react';
import axios from 'axios'

import GlobalFooter from "../components/GlobalFooter";
import PlanCardList from '../components/Plan/PlanCardList';
import Features from '../components/Plan/Features';
import { Tag, Modal, PageHeader } from 'antd';
import RecurlyPaymentForm from '../components/RecurlyPaymentForm';
import { constants } from '../common/constants';

const NewPlans = ({
  ...props
}) => {

  const [plans, setPlans] = useState([])
  const [viewablePlans, setViewablePlans] = useState([])
  const [isMonthly, setIsMonthly] = useState(false)
  const [isShowingFeatures, setIsShowingFeatures] = useState(false) 

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [recurlyOptions, setRecurlyOptions] = useState({
    targetPlan: null,
    currentPlan: null,
    purpose: null
  })

  useEffect(() => {
    getPlans();
  }, [])

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };


  const handleSelectPlan = async (plan) => {


    if(['free','FREE'].includes(plan.planCode)) {

      const registerObject = {
        registerFromPlan: true, 
        plan: plan
      }

      // Construct the new route with the plan code and register object
      const newRoute = `/register/${plan.planCode}`;

      // Retrieve current query parameters
      const queryParams = props.location.search;

      // Push the new route along with the current query parameters
      props.history.push(newRoute + queryParams, registerObject);    
      
      return;
    } 
    else {
      handleRecurlyModal({
        targetPlan: plan,
        currentPlan: null,
        purpose: 'checkout-register'
      })
    }
  };


  const getPlans = async () => {
    const response = await axios.get('/v1/plans/public')

    const free = response.data.data.find(plan => plan.planCode === 'free')
    const goldMonth = response.data.data.find(plan => plan.planCode === 'gold')
    const goldyear = response.data.data.find(plan => plan.planCode === 'goldyear')
    const platinumMonth = response.data.data.find(plan => plan.planCode === 'platinum')
    const platinumyear = response.data.data.find(plan => plan.planCode === 'platinumyear')

    setPlans({
      free, 
      gold: {
        month: goldMonth,
        year: goldyear
      },
      platinum: {
        month: platinumMonth,
        year: platinumyear
      }
    })

    setViewablePlans([
      free, 
      goldyear, 
      platinumyear
    ])

    setIsShowingFeatures(true);
  }

  const handleToggleBillingCycle = () => {
    setIsMonthly(!isMonthly)

    if(isMonthly) {
      setViewablePlans([plans.free, plans.gold.year, plans.platinum.year])
    } else {
      setViewablePlans([plans.free, plans.gold.month, plans.platinum.month])
    }
  }

  const handleToggleFeatureList = () => {
    setIsShowingFeatures(!isShowingFeatures)
  }

  const handleRecurlyModal = (options) => {
    setRecurlyOptions({
      ...options,
    })

    showModal();
  };

  const goBack = () => {
    window.history.back();
  }

  return (
    <>
      <div>
        <div className="stripe-checkout-banner">
          <PageHeader title={<div><a className="navbar-brand" href={constants.appHome}><img style={{ height: 35, width: 190 }} src="/assets/images/Reship_Logo_Pur.png" alt="logo" /></a> </div>} onBack={goBack}/>
        </div>
        <Modal title="Subscribe" visible={isModalOpen} onCancel={handleCancel} footer={null}>
        <div>
          <RecurlyPaymentForm
            options={recurlyOptions}
            getPlans={getPlans}
          />
        </div>
      </Modal>
        <div className="content-area">
          <div className="plans-wrapper" style={{ width: "100%", margin: '20px 0px' }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
            }}>
              <div className="btn-toggle">
                <button
                  className={`ddpEnable btn ${isMonthly ? 'btn-selected' : ''}`}
                  disabled={false}
                  onClick={handleToggleBillingCycle}
                >
                  Monthly
                </button>
                <button
                  className={`ddpDisable btn ${!isMonthly ? 'btn-selected' : ''}`}
                  disabled={false}
                  onClick={handleToggleBillingCycle}
                >
                  Yearly <Tag style={{ borderRadius: 10, margin: '0px 5px' }} color="blue">Save 2 Months</Tag>
                </button>
              </div>
            </div>
            <div style={{ 
              padding: 15,
              display: 'flex',
              justifyContent: 'center',
            }}>
            <PlanCardList 
              plans={viewablePlans}
              handleSelectPlan={handleSelectPlan}
            />
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
              {
                isShowingFeatures ? (
                  <button className='btn btn-outline-primary' style={{ margin: '0 auto' }} onClick={handleToggleFeatureList}> 
                    <i className="material-icons">remove</i>
                    Close features 
                  </button>
            
                ) : 
                <button className='btn btn-outline-primary' style={{ margin: '0 auto' }} onClick={handleToggleFeatureList}> 
                  <i className="material-icons">add</i>
                  Full list of features 
                </button>
                }
              {
                isShowingFeatures && 
                <div style={{ margin: '0 auto', marginTop: 10 }}>
                  <Features 
                    plans={viewablePlans}
                  />
                </div>
              }
            </div>
          </div>
          <div className="plan-clarification">
            <span>* For your information, all our pricing is denominated in U.S. Dollars (USD).</span>
            <br/>
            <span>* Please be aware that for certain countries, additional Goods and Services Tax (GST) may be applied in accordance with governmental regulations.</span>
          </div>
        </div>
        <GlobalFooter/>
      </div>
    </>
  )
}

export default NewPlans;